"use client";

import React from "react";
import styles from "./ChatBotSupportListItem.module.scss";
import Text from "../Text";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import { useAppDispatch } from "@lib/redux/hooks";
import { setCopilotCarData } from "@lib/redux/slices/carDataSlice";

interface ChatBotSupportListItemProps {
  title: string;
  brandName?: string;
  modelName?: string;
  cityName?: string;
  isLoggedIn?: boolean;
  pageType?: string;
  carAvailability?: string;
}

export default function ChatBotSupportListItem({
  title,
  brandName,
  modelName,
  cityName,
  pageType,
  carAvailability,
}: ChatBotSupportListItemProps) {
  const dispatch = useAppDispatch();
  
  const handleChatbotClick = async (title?: string) => {
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_chat_bot",
        prompt: title || "",
        section: "Chat",
        car_availability: carAvailability,
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
      },
      pageType: pageType,
    });

    dispatch(setCopilotCarData({
      make: brandName || "",
      model: modelName || "",
    }));

    (window as any).copilot.open();
    (window as any).copilot.sendMessage(title);
  };

  return (
    <div className={styles.root} onClick={() => handleChatbotClick(title)}>
      <Text className={styles.listItem}>{title}</Text>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform={"rotate(-90)"}
        className={styles.icon}
      >
        <path
          d="M18.5243 10.0174C18.7865 9.75662 18.7864 9.3322 18.5239 9.0716L18.4184 8.96682C18.1583 8.70853 17.7384 8.70871 17.4785 8.96721L12.005 14.4113L6.52147 8.96643C6.26151 8.7083 5.84196 8.7083 5.582 8.96643L5.47642 9.07127C5.21385 9.33199 5.21385 9.75668 5.47642 10.0174L11.5349 16.0332C11.795 16.2915 12.2148 16.2914 12.4747 16.0329L18.5243 10.0174Z"
          fill="#FFFFFF"
        />
      </svg>
    </div>
  );
}
